import React, { CSSProperties } from 'react';
import numeral from 'numeral';

interface AssessmentAndTaxesProps {
  detailListStyle: CSSProperties,
  taxAssessedValue: number | undefined,
  annualTax: number | undefined,
  taxYear: Date | undefined,
}

const AssessmentAndTaxes = ({detailListStyle, taxAssessedValue, annualTax, taxYear} : AssessmentAndTaxesProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-receipt me-2" />
          Assessment &amp; Taxes
			</p>
			<ul style={detailListStyle}>
				{taxAssessedValue ? <li><span className="cc-font-weight--normal">Assessed Value:</span> ${numeral(taxAssessedValue).format()}</li> : ''}
				{annualTax ? <li><span className="cc-font-weight--normal">Annual Tax:</span> ${numeral(annualTax).format()}</li> : ''}
				{taxYear ? <li><span className="cc-font-weight--normal">Tax Year:</span> {taxYear}</li> : ''}
            
				{(!taxAssessedValue && !annualTax && !taxYear) ? 
					<li>None listed</li>
					: ''
				}
			</ul>
		</React.Fragment>
	);
};

export default AssessmentAndTaxes;